"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileDownloader = void 0;
var FileDownloader = /** @class */ (function () {
    function FileDownloader(configuration, httpClient) {
        this.configuration = configuration;
        this.httpClient = httpClient;
    }
    /**
     * @param {string} path
     * @param {DownloadUrlRequest?} downloadUrlRequest
     * @returns {Promise<DownloadUrl>>}
     */
    FileDownloader.prototype.getDownloadUrl = function (path, downloadUrlRequest) {
        var params = {
            path: path,
        };
        if (downloadUrlRequest) {
            params = __assign(__assign({}, params), downloadUrlRequest);
        }
        return this.httpClient
            .get("https://" + this.configuration.domain + "/_api/download/secure_url", params)
            .then(function (response) {
            return response.payload;
        }, function (error) {
            return Promise.reject(error);
        });
    };
    return FileDownloader;
}());
exports.FileDownloader = FileDownloader;
//# sourceMappingURL=browser-file-downloader.js.map